import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  canceledContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingX: 3,
    paddingY: 2,
    marginBottom: 2,
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
  },
  canceledText: {
    color: theme.palette.text.secondary,
  },
});
